module.exports = "/images/vendor/flag-icon-css/flags/4x3/mr.svg?a46829f17f8f3c4c5a5929be8e3fc599";